import { CHANGE_CURRENT_PROJECT_PAGE, PROJECT_LAUNCH_LIST, SEARCH_JOBS, SET_PROJECT_ITEMS_PER_PAGE, PROJECT_STATUS_FILTER, VIEW_LAUNCH_DETAILS, CHANGE_VIEW_LAUNCH_TAB, PROJECT_RENEWAL_LIST, GET_LEAVE_REQUEST, GET_LEAVE_BALANCE, CLEAR_PROJECT_LAUNCH_DATE_FILTER, SET_PROJECT_LAUNCH_DATE_FILTER} from "../actions/projectLaunchAction";




const initialState = {
  projectLaunchListing: [],
  projectLaunchTotalResults: null,
  projectLaunchTotalPages: null,
  projectLaunchPageIds: [],
  fetchingData: true,
  projectLaunchSearchText: "",
  projectLaunchCurrentPage: 1,
  lauchListResultPerPage: 10,
  projectLaunchStatusFliter: [],
  initialTab: 0,
  tabValues: {},
  projectRenewalsListing: [],
  leaveReuest:[],
  leaveBalance:[],
    dateFilters: {
    launch_date: null,
    latest_start_date: null,
    termination_date: null,
    tentative_end_date: null,
  },
};


const projectLaunchReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROJECT_LAUNCH_LIST: {
      return {
        ...state,
        projectLaunchListing: action.payload.results,
        projectLaunchTotalResults: action.payload.total_results,
        projectLaunchTotalPages: action.payload.total_pages,
        projectLaunchPageIds: action.payload.page_ids,
        fetchingData: false,
      };
    }

        case CHANGE_CURRENT_PROJECT_PAGE: {
          return {
            ...state,
            projectLaunchCurrentPage: action.payload,
          };
        }
    
        case SET_PROJECT_ITEMS_PER_PAGE: {
          return {
            ...state,
            lauchListResultPerPage: action.payload,
          };
        }
     case SEARCH_JOBS: {
          return {
            ...state,
            projectLaunchSearchText: action.payload,
          };
        }

        case PROJECT_STATUS_FILTER: {
          return {
            ...state,
            projectLaunchStatusFliter: action?.payload || [],
          };
        }

         case VIEW_LAUNCH_DETAILS: {
          return {
            ...state,
            launchDetails: action.payload,
          };
        }

      case CHANGE_VIEW_LAUNCH_TAB: {
      return {
        ...state,
        initialTab: action.payload,
      };
    }

     case PROJECT_RENEWAL_LIST: {
          return {
            ...state,
           projectRenewalsListing: action.payload,
           fetchingData: false,
          };
        }
    case GET_LEAVE_REQUEST: {
          return {
            ...state,
           leaveReuest: action.payload,
           fetchingData: false,
          };
        }
        case GET_LEAVE_BALANCE: {
          return {
            ...state,
           leaveBalance: action.payload,
           fetchingData: false,
          };
        }
            case SET_PROJECT_LAUNCH_DATE_FILTER:
          return {
            ...state,
            dateFilters: {
              ...state.dateFilters,
              [action.payload.key]: action.payload.range,
            },
            projectLaunchCurrentPage: 1,
          };
        
        case CLEAR_PROJECT_LAUNCH_DATE_FILTER:
          return {
            ...state,
            dateFilters: {
              ...state.dateFilters,
              [action.payload]: null,
            },
            projectLaunchCurrentPage: 1,
          };

    default:
      return state;
  }
};

export default projectLaunchReducer;